// extracted by mini-css-extract-plugin
export default {"hotels__list":"hotels-list_hotels__list__YjsPG","hotels__subtitle":"hotels-list_hotels__subtitle__3UZBQ","counter":"hotels-list_counter__SD5C5"};